<button class="fab" (click)="handleClick($event)" [attr.disabled]="disabled">
  <cs-icon [name]="icon"></cs-icon>
</button>
@if (label) {
  <cs-label [attr.disabled]="disabled ? '' : null">
    {{ label }}
  </cs-label>
}